import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/AbsoluteButton';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import * as navigationHelper from '../../../helpers/navigationHelper';
import _ from 'lodash';

class TitleScreenImageBased extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            show_project_title: appHelper.isDefined(this.props.screen.show_project_title) ? this.props.screen.show_project_title : true,
            locale: appHelper.getLocalData(props.screen),
            renderedObjects: [],
            assets: {
                large_background: {
                    src: "",

                },
                mobile_background: {
                    src: "",
                },
                current_background: {
                    src: "",
                }
            },
            currentAssetParams: appHelper.getLocalData(props.screen).assets.large_background,
            isDisabled: false,
            env: enviromentHelper.getEnvironment(),
            updateBackgroundAssets: false,
            initialised: false,
            updateButtonStyles: false,
            button_styles: {},
            adaptiveBackgroundSizes: {
                lg: {
                    landscape: objectConstants.LARGE_BACKGROUND,
                    portrait: objectConstants.LARGE_BACKGROUND,
                },
                md: {
                    landscape: objectConstants.LARGE_BACKGROUND,
                    portrait: objectConstants.LARGE_BACKGROUND,
                },
                sm: {
                    landscape: objectConstants.LARGE_BACKGROUND,
                    portrait: objectConstants.MOBILE_BACKGROUND,
                },
                xs: {
                    landscape: objectConstants.LARGE_BACKGROUND,
                    portrait: objectConstants.MOBILE_BACKGROUND,
                }
            },
            start_label: appHelper.getLocaleString("start_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            update_assets: false,
        };
        this.getLocale = this.getLocale.bind(this);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getButtonLabel = this.getButtonLabel.bind(this);
        this.componentWatcher = this.componentWatcher.bind(this);
        this.setBackgroundAsset = this.setBackgroundAsset.bind(this);
        this.setButtonStyles = this.setButtonStyles.bind(this);
        this.getCurrentBackgroundSize = this.getCurrentBackgroundSize.bind(this);
        this.setBackgroundClass = this.setBackgroundClass.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
    }

    componentDidMount() {
        this.setButtonStyles();
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(false);
        window.addEventListener("resize", this.componentWatcher);
        this.getLocale();
        this.getAssets();
        setTimeout(function () {
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }.bind(this), 1000);
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                start_label: appHelper.getLocaleString("start_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                update_assets: true,
            });

        }
    }

    componentDidUpdate() {
        //console.log(`updateBackgroundAssets`);
        //console.log(this.state.button_styles);
        if (this.state.updateBackgroundAssets) {
            this.setBackgroundAsset();
        }

        if (this.state.updateButtonStyles) {
            this.setButtonStyles();
        }

        if(this.state.update_assets){
            this.getAssets();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
    }

    componentWatcher() {
        let env = enviromentHelper.getEnvironment();
        if ((env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation)) {
            this.setState({env: env, updateBackgroundAssets: true});
        }
    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    getCurrentBackgroundSize() {
        return this.state.adaptiveBackgroundSizes[this.state.env.window.size][this.state.env.window.orientation];
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.props.actions.setScreenTitle(locale.title);
        this.setState({locale: Object.assign({}, locale)});
    }


    getAssets() {
        this.setState({update_assets: false});
        let large_background = {};
        let mobile_background = {};
        if (appHelper.isDefined(this.state.locale.assets.large_background)) {
            large_background = appHelper.getLargeBackgroundAsset(this.state.locale.assets.large_background.upload);
            large_background = appHelper.getLocalData(large_background);

        }
        if (appHelper.isDefined(this.state.locale.assets.mobile_background)) {
            mobile_background = appHelper.getMobileBackgroundAsset(this.state.locale.assets.mobile_background.upload);
            mobile_background = appHelper.getLocalData(mobile_background);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                large_background: appHelper.isDefined(large_background.src) ? large_background : this.state.locale.assets.large_background,
                mobile_background: appHelper.isDefined(mobile_background.src) ? mobile_background : this.state.locale.assets.mobile_background,
                current_background: appHelper.isDefined(large_background.src) ? large_background : this.state.locale.assets.large_background,
            }),
            currentAssetParams: this.state.locale.assets.large_background,
            updateButtonStyles: true,
            updateBackgroundAssets: true,

        });
    }

    setBackgroundAsset() {
        this.setState({
            assets: Object.assign({}, this.state.assets, {
                current_background: this.state.assets[this.getCurrentBackgroundSize()],
            }),
            currentAssetParams: this.state.screen.assets[this.getCurrentBackgroundSize()],
            updateBackgroundAssets: false,
            updateButtonStyles: true,
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        return this.props.biteCallbacks.getBiteId();
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status
        };

        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                    let next_lesson_location =  navigationHelper.getNextLessonLocation(this.getScreenId());
                    this.props.actions.setNextButtonState(true,next_lesson_location);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    onProgressionClicked() {
        this.setState({isDisabled: true});

        this.navigateToNextScreen();
    }

    navigateToNextScreen() {
        let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
        if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
            this.context.router.push('menu');
        } else {
            this.props.actions.setNextLessonLocation(this.getScreenId());
        }
    }

    setClass() {
        return this.state.screen.include_logo ? "logo" : "";
    }

    getButtonLabel() {
        let bite = appHelper.getBiteById(this.getBiteId());
        let biteIndex = appHelper.getArrayObjectIndexByKey(this.props.userData.bites,"bite_id",bite.bite_id);
        let screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens,"screen_id",this.state.screen.screen_id);
        if (biteIndex == 0 && screenIndex == 0) {
            return this.state.start_label;
        } else {
            return this.state.continue_label;
        }
    }

    setButtonStyles() {
        let btn = this.refs.abs_btn;
        let bg = this.refs.title_background;



        if (appHelper.isDefined(btn) && appHelper.isDefined(bg)) {
            let  currentScreenAssetParams = this.state.screen.assets[this.getCurrentBackgroundSize()];
            let  currentAssetParams = this.state.locale.assets[this.getCurrentBackgroundSize()];
            let top = currentAssetParams.button_location.top;
            let left = currentAssetParams.button_location.left;


            let bgHeight = bg.offsetHeight;
            let bgWidth = bg.offsetWidth;

            //console.log(`bgWidth: ${bgWidth}`);
            //console.log(`bgHeight: ${bgHeight}`);

            let buttonHeight = btn.offsetHeight;
            let buttonWidth = btn.offsetWidth;
            //console.log(`buttonWidth: ${buttonWidth}`);
            //console.log(`buttonHeight: ${buttonHeight}`);

            let pHeight = (bgHeight / 100) * top;
            let pWidth = (bgWidth / 100) * left;
            //console.log(`pWidth: (${bgWidth} / 100) * ${left} = ${pWidth}`);
            let moveTop = pHeight - (buttonHeight / 2);

            let btnBtm = moveTop + buttonHeight;

            if (btnBtm > bgHeight) {
                moveTop = bgHeight - buttonHeight;
            }

            let moveLeft = pWidth - (buttonWidth / 2);
            let btnRight = moveLeft + buttonWidth;

            if (btnRight > bgWidth) {
                moveLeft = bgWidth - buttonWidth;
            }

            //console.log(`moveLeft: ${pWidth} - (${buttonWidth} / 2) = ${moveLeft}`);

            let moveTopPerc = (moveTop / bgHeight) * 100;
            let moveLeftPerc = (moveLeft / bgWidth) * 100;

            if (moveTopPerc < 0) {
                moveTopPerc = 0;
            } else if (moveTop > bgHeight) {
                //console.log(`${moveTop} > ${bgHeight}`)
                moveTopPerc = 100;
            }

            if (moveLeftPerc < 0) {
                moveLeftPerc = 0;
            } else if (moveLeftPerc > 100) {
                moveLeftPerc = 100;
            }

            if (currentScreenAssetParams.override_theme_button_styles) {

                this.setState({
                    initialised: true,
                    button_styles: Object.assign({}, {}, {
                        top: `${moveTopPerc}%`,
                        left: `${moveLeftPerc}%`,
                        backgroundColor: currentScreenAssetParams.button_background_color,
                        color: currentScreenAssetParams.button_text_color
                    }),
                    updateButtonStyles: false
                });
            } else {
                this.setState({
                    initialised: true,
                    button_styles: Object.assign({}, {}, {
                        top: `${moveTopPerc}%`,
                        left: `${moveLeftPerc}%`
                    }),
                    updateButtonStyles: false
                });
            }

        } else {
            this.setState({initialised: true, button_styles: Object.assign({}, {}), updateButtonStyles: false});
        }

    }

    setBackgroundClass() {
        return this.getCurrentBackgroundSize() === objectConstants.LARGE_BACKGROUND ? "background-container title-screen" : "background-container ";
    }

    render() {
        return (
            <div className="customer-scenario">
                <div className={this.setBackgroundClass()}>
                    <img src={this.getImagePath(this.state.assets.current_background.src)} className="title-screen" alt=""/>
                </div>
                <div className="screen-container" ref="title_background">
                    {
                        appHelper.isDefined(this.state.locale.title)
                            ?
                            <h1 className={`hidden-el`} dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                            :
                            null
                    }
                        <button className={`btn btn-lg guroo-btn abs-btn continue-btn`} ref={'abs_btn'}
                                style={this.state.button_styles} disabled={this.state.isDisabled}
                                onClick={this.onProgressionClicked}>{this.getButtonLabel()}</button>

                </div>
            </div>
        );
    }
}

TitleScreenImageBased.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
};

TitleScreenImageBased.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        titles: state.titles,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleScreenImageBased);



/** WEBPACK FOOTER **
 ** ./src/components/screens/titleScreen/TitleScreenImageBased.js
 **/